import classnames from 'classnames'
import { isNil } from 'ramda'
import React,
{ Component } from 'react'
import { DropTarget } from 'react-dnd'

const boxTarget = {
  drop(props, monitor, component) {
    const settingsObject = props.currentSettingsObject
    const hasDroppedOnChild = monitor.didDrop()
    const droppedChild = monitor.getItem()
    const targetId = props.id

    if (targetId === droppedChild.id) {
      return
    }

    if (!isNil(droppedChild.id)) {
      props.onReorder({
        target: targetId,
        current: droppedChild.id,
        settingsObject
      })
    }

    component.setState({
      hasDropped: true,
      hasDroppedOnChild
    })
  },
}

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  isOverCurrent: monitor.isOver({ shallow: true }),
  isDragging: !!monitor.getItem()
})

class Droppable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasDropped: false,
      hasDroppedOnChild: false,
    }
  }

  render() {
    const {
      isOver,
      isOverCurrent,
      connectDropTarget,
      children,
    } = this.props

    const dropTarget = (
      <div className={classnames("drop-target", {
        'drop-target--over' : isOver,
        'drop-target--over-current' : isOverCurrent,
      })}>
        <div className="drop-dot" />
        <div>{children}</div>
      </div>
    )

    return connectDropTarget(dropTarget)
  }
}

export default DropTarget(props => props.type, boxTarget, collect)(Droppable)
